import React from 'react'
import styles from '~/styles/atoms/title/title.module.scss'

import Icon, { IconSize } from '~/components/atoms/icon/Icon'
import { GeneralIconTag } from '~/common/define/icon'
import StrongText from '~/components/atoms/text/StrongText'

interface Props {
  mainText: string
}

const AlertTitle = ({mainText}: Props) => {
  return (
    <h1 className={styles.alert}>
      <Icon tag={GeneralIconTag.ALERT_LARGE} size={IconSize.XX_LARGE}/>
      <StrongText>{mainText}</StrongText>
    </h1>
  )
}

export default AlertTitle